import Component from './tiktok_campaign_prize.vue'
export default Component
